module.exports = __webpack_public_path__ + "img/e26e47745052dad94e8402ad652d9b5a.7bc09d92.png";